import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import KpiList from "@/pages/KpiList";
import KpiDetail from "@/pages/KpiDetail";
import Realisasi from "@/pages/Realisasi";
import ImprovementList from "@/pages/ImprovementList";
import ImprovementDetail from "@/pages/ImprovementDetail";
import MeetingReport from "@/pages/MeetingReport";
import MatrixPrint from "@/pages/MatrixPrint";
import MasterData from "@/pages/MasterData";
import Guide from "@/pages/Guide";
import AuditLog from "@/pages/AuditLog";
import SettingsPage from "@/pages/SettingsPage";
import OrgMatrix from "@/pages/OrgMatrix";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Memuat sesi...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/organisasi" element={<OrgMatrix />} />
        <Route path="/kpi" element={<KpiList />} />
        <Route path="/kpi/:id" element={<KpiDetail />} />
        <Route path="/realisasi" element={<Realisasi />} />
        <Route path="/improvement" element={<ImprovementList />} />
        <Route path="/improvement/:id" element={<ImprovementDetail />} />
        <Route path="/laporan" element={<MeetingReport />} />
        <Route path="/matrix" element={<MatrixPrint />} />
        <Route path="/master" element={<MasterData />} />
        <Route path="/panduan" element={<Guide />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/pengaturan" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Router />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}
